import { render } from "./DocsInfo.vue?vue&type=template&id=0aeaff14&scoped=true"
import script from "./DocsInfo.vue?vue&type=script&lang=js"
export * from "./DocsInfo.vue?vue&type=script&lang=js"

import "./DocsInfo.vue?vue&type=style&index=0&id=0aeaff14&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aeaff14"]])

export default __exports__